import { MintBurnPage } from "@src/components/MintBurnPage/MintBurnPage";

export default MintBurnPage;
